import {Middleware} from '@reduxjs/toolkit'

import {Sentry} from '@web/helpers/log'

import {ApplyRootState as State} from '../../../interfaces'

const sentryTransaction: Middleware<object, State> =
    ({getState}) =>
    (next) =>
    (action) => {
        const nextState = getState()

        Sentry.setTags({
            seqId: nextState.common.seqID,
        })

        next(action)
    }

export default sentryTransaction
